export const environment = {
    production: false,
    CdcUskey:"4_uOg5XlqFREry4h_WP5YVRQ",
    CdcUkKey:"3_LNDbLKIOk2X4oRqnhL_FAr7ncHUbjmR_8bvc8w0KyE0S4plMKBPZ05WZ0UllPP7l",
    sapcustomerid:"",
    cdcCust:"",
    /* CookieUs:"88ca71f2-9210-4800-81ec-37cd6675b98e",
    CookieUk:"a8e54e33-d1df-4545-a1eb-239c1eff16d1", */
    CookieUs:"4b9a2748-81b2-43af-87bf-50d897d432a6-test",
    CookieUk:"a8e54e33-d1df-4545-a1eb-239c1eff16d1",
    GtmUsId:"GTM-WWZ4T9K",
    GtmUkId:"GTM-M53ZPN7",
    captchaSiteKey:"6Lc2YhEqAAAAAAI3geswvn7Jv5MO5lr_z6GK4jQp"
  };


 


